export default __webpack_public_path__ + "static/media/icMortgageSingle.f4530432.svg";